
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/blogs/[category]",
      function () {
        return require("private-next-pages/c/blogs/[category].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/blogs/[category]"])
      });
    }
  